import type { JSX } from 'react'

import { TopNumber2SC } from './TopNumbers.styled'

export const Top2 = (): JSX.Element => (
  <TopNumber2SC
    width='127'
    height='192'
    viewBox='0 0 127 192'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M127 165.153V192H0V169.763L64.5855 101.424C74.8974 90.7571 81.953 82.0791 85.7521 75.3898C89.5513 68.5198 91.4509 61.8305 91.4509 55.322C91.4509 45.7401 88.2849 38.5085 81.953 33.6271C75.802 28.565 66.9373 26.0339 55.359 26.0339C37.8105 26.0339 21.3476 31.096 5.97008 41.2203V13.2881C21.3476 4.42938 38.1724 0 56.4444 0C76.1638 0 91.9031 4.70056 103.662 14.1017C115.422 23.5028 121.301 36.1582 121.301 52.0678C121.301 71.5932 112.437 90.5763 94.7073 109.017L42.062 165.153H127Z'
      fill='url(#paint0_linear_5096_100052)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5096_100052'
        x1='-20.6239'
        y1='3.01695'
        x2='166.793'
        y2='171.207'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EFEFEF' stopOpacity='0.9' />
        <stop offset='1' stopColor='#7C7984' stopOpacity='0.2' />
      </linearGradient>
    </defs>
  </TopNumber2SC>
)
